import type { ReceiptTemplate } from '../schema';

export const sevenElevenTemplate: ReceiptTemplate = {
  id: '7-eleven',
  name: '7-Eleven Receipt',
  brand: '7-Eleven',
  description: 'Convenience store receipt template inspired by 7-Eleven',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#000000',
    showWatermark: false,
    currency: 'none',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: '7e-spacer-top',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 24,
      },
    },
    {
      id: '7e-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/7-eleven.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 16,
        addressLines: [
          '3992 HAVANA ST',
          'DENVER CO 80239',
          '3033719329',
          'STORE#: 35053',
        ],
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: '7e-unit-term',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: '7e-unit', label: 'UNIT ID:', value: '00093505394' },
        ],
        column2: [
          { id: '7e-term', label: 'TERM ID:', value: '21' },
        ],
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: '7e-thanks',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'THANKS FOR SHOPPING\n7-ELEVEN',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: '7e-spacer-1',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 8,
      },
    },
    {
      id: '7e-sale-header',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '--== SALE TRANSACTION ==--',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: '7e-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        quantityPosition: 'left',
        showHeader: false,
        showHeaderDivider: false,
        headerLabels: {
          quantity: 'Qty',
          item: 'Item',
          amount: 'Price',
        },
        items: [
          { id: '7e-item-1', quantity: '1', name: 'Avocado', price: '0.95F' },
          { id: '7e-item-2', quantity: '1', name: 'GV Milk 2%', price: '3.64F' },
          { id: '7e-item-3', quantity: '1', name: 'GV Bread Wheat', price: '1.28F' },
          { id: '7e-item-4', quantity: '1', name: 'GV Eggs Large', price: '4.87F' },
          { id: '7e-item-5', quantity: '1', name: 'Tide Pods', price: '14.97T' },
        ],
        showTopDivider: false,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: '7e-spacer-2',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 8,
      },
    },
    {
      id: '7e-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 0,
        lines: [
          { id: '7e-subtotal', label: 'SUBTOTAL', value: '25.71', isBold: false, isLarge: false },
          { id: '7e-tax', label: 'High Tax ON 14.97', value: '1.20', isBold: false, isLarge: false },
          { id: '7e-total-due', label: 'TOTAL DUE', value: '26.91', isBold: false, isLarge: false },
          { id: '7e-payment', label: 'MASTERCR', value: '26.91', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 30,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: '7e-card-info',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'ACCT#: XXXX XXXX XXXX 0771\nAPPROVAL#: 00-620529\nAUTH CODE: 0\nAPPROVAL TIME: 071122\nSTORE#: 35053\nTERM# :00093505394 21\nREF# : 100030425180711\nINVOICE#: 071122\n00 - APPROVED',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: '7e-divider-dashed-1',
      type: 'divider',
      enabled: true,
      config: {
        style: 'dashed',
        spacing: 4,
      },
    },
    {
      id: '7e-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'SALE\nBatch: 10 Seq Num: 3\nTerm ID: 1\nWorkstation ID: 1\nYour opinion counts! Enter to Win\n1 of 60 $25 gas gift cards!!!\nProvide feedback at www.gasvisit.com',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: '7e-divider-dashed-2',
      type: 'divider',
      enabled: true,
      config: {
        style: 'dashed',
        spacing: 4,
      },
    },
  ],
};
